import { useAuth } from "../lib/auth";
import UsersAdminPanel from "./UsersAdminPanel";

const ROLE_DESCRIPTIONS = [
  ["Owner / Super Admin", "Full control — users, billing, settings, integrations, and all data."],
  ["Admin", "Manage users, automations, templates, lead routing, and all reports."],
  ["Sales Manager", "Reassign leads, monitor follow-up, approve trades, see all sales reports."],
  ["Salesperson", "Work assigned leads — notes, texts, emails, tasks, deals, trades."],
  ["BDC / Appointment Setter", "Contact leads and book appointments. Limited deal access."],
  ["Finance / F&I", "View sold/pending deals, credit apps, lender notes, warranty products."],
  ["Service / Parts", "Ownership info, service interests, recall notes, customer comms history."],
  ["Inventory Manager", "Manage vehicles, pricing, photos, options, stock numbers."],
  ["Marketing", "Build campaigns, manage templates, segment lists, view campaign results."],
  ["Read-Only / Auditor", "View records and reports only — no edits, deletes, or messages."],
  ["Guest / Limited", "Restricted view of specific records you grant — vendors, temps."],
];

export default function SettingsTab() {
  const { user } = useAuth();
  const canManageUsers = ["owner", "super_admin", "dealer", "admin", "sales_manager"].includes(user?.role);

  return (
    <div className="space-y-8 max-w-5xl" data-testid="settings-tab">
      {/* Header */}
      <div>
        <div className="text-[10px] font-bold uppercase tracking-widest text-[var(--ssc-blue)]">Settings</div>
        <h1 className="text-white font-black text-2xl mt-1">Workspace Settings</h1>
        <p className="text-white/60 text-sm mt-1">
          Manage your team, roles, and permissions.
        </p>
      </div>

      {canManageUsers ? (
        <UsersAdminPanel currentUser={user} />
      ) : (
        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 text-white/70 text-sm" data-testid="users-no-permission">
          You don't have permission to manage team users. Contact your Owner or Admin if you need access.
        </div>
      )}

      {/* Role reference card */}
      <div className="bg-white/5 border border-white/10 rounded-2xl p-5" data-testid="roles-reference">
        <div className="text-[10px] font-bold uppercase tracking-widest text-[var(--ssc-silver)] mb-3">Role Reference</div>
        <ul className="space-y-2.5">
          {ROLE_DESCRIPTIONS.map(([name, desc]) => (
            <li key={name} className="text-sm">
              <span className="text-white font-bold">{name}</span>
              <span className="text-white/60"> — {desc}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
